var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.29 7.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.22,7.3v-1.04H1.4V1.36l-1.4,.19V.71L1.84,.12h.86V6.26h1.18v1.04H.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.52,1.61c-.48-.4-.92-.55-1.43-.55-1.09,0-1.69,.98-1.76,2.41h.02c.59-.63,1.24-.78,1.78-.78,1.34,0,2.16,.87,2.16,2.28s-.98,2.45-2.57,2.45c-1.7,0-2.69-1.23-2.69-3.36S6.07,0,8.07,0c.77,0,1.44,.19,2.05,.65l-.6,.96Zm-1.79,4.77c.79,0,1.27-.55,1.27-1.38s-.45-1.26-1.24-1.26c-.59,0-1.18,.41-1.4,.97,0,.94,.46,1.67,1.37,1.67Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16);
export default __webpack_public_path__ + "static/media/16.fdf5a875db08691f34aa512c0436d8c9.svg";
export { ForwardRef as ReactComponent };